import { ResizeObserver as Polyfill } from '@juggle/resize-observer';
const ResizeObserver = window.ResizeObserver || Polyfill;

// HEIGHT MATCHING
// data-hm-group = wrapper for all the items to have their sections height-matched
// data-hm-item = the items to have their sections height-matched. We match based on the y-position of this element.
// data-hm-section = part(s) of the item to be height-matched, eg. data-hm-section="title"

class HeightMatchGroup {

    constructor(el) {
        // store wrapper
        this.el = el;
        this.width = 0;
        this.resizeRequested = false;
        this.resizeTimeout = null;
        this.setLabels = [];
        this.allSections = []; // used to clear all sections
        // store items
        this.items = [];
        let findItems = this.el.querySelectorAll('*[data-hm-item]');
        if(findItems != null) {
            // loop through items adding all sections
            for(let x = 0, l = findItems.length; x < l; x++) {
                // store item
                this.items[x] = {
                    obj : findItems[x],
                    sections : []
                };
                // find sections
                let findSections = findItems[x].querySelectorAll('*[data-hm-section]');
                if(findSections != null) {
                    findSections.forEach(s => {
                        let setLabel = (s.dataset.hmSection + '').toLowerCase();
                        // find set or create it
                        let setIndex = this.setLabels.indexOf(setLabel);
                        if (setIndex < 0) {
                            this.setLabels.push(setLabel); // store label
                            setIndex = this.setLabels.length - 1;
                        }
                        // store section element in item array
                        this.items[x].sections[setIndex] = s; // create new set array to store element
                        // also store in allSections array (for fast clearing)
                        this.allSections.push(s);
                    });
                }
            }
        }
        // add resize observer

        this.ro = new ResizeObserver(entries => {
            for (let entry of entries) {
                const cr = entry.contentRect;
                if(cr.width != this.width) {
                    this.width = cr.width;
                    if(!this.resizeRequested) {
                        this.requestResize();
                    }
                }
            }
        });
        this.ro.observe(this.el); // Watch dimension changes wrapping element
        // add bootstrap collapse listener
        let findCollapses = [...el.querySelectorAll('.collapse')];
        findCollapses.forEach(c => {
            c.addEventListener('hidden.bs.collapse', () => {
                if(!this.resizeRequested) {
                    this.requestResize();
                }
            });
            c.addEventListener('shown.bs.collapse', () => {
                if(!this.resizeRequested) {
                    this.requestResize();
                }
            });
        });
    }

    clearSections() {
        for(let x = 0, l = this.allSections.length; x < l; x++) {
            this.allSections[x].style.minHeight = 'unset';
        }
    }

    update() {
        let ranges = [],
            y = 0,
            startIndex = 0,
            endIndex = 0,
            arrayFinalIndex = this.items.length - 1;
        for(let x = 0; x <= arrayFinalIndex; x++) {
            // get offsset top of item
            let rect = this.items[x].obj.getBoundingClientRect(),
                t = Math.floor(rect.top);
            // compare y
            if(x > 0) {
                if(Math.abs(t - y) > 2) { // t is not within 2 pixels of y
                    // finish this row
                    endIndex = x - 1;
                    ranges.push({
                        start : startIndex,
                        end : endIndex
                    });
                    startIndex = x;
                }
            }
            // update y value for new row
            y = t;
        }
        // check for last set of items that have not been updated
        if(startIndex < arrayFinalIndex) ranges.push({
            start : startIndex,
            end : arrayFinalIndex
        });
        // do all updates in ranges
        this.updateItems(ranges);
        // reset resizeRequested
        this.resizeRequested = false;
    }

    updateItems(ranges) {
        // loop through ranges
        for(let r = 0; r < ranges.length; r++) {
            // loop through sectionLabels array
            for(let i = 0; i < this.setLabels.length; i++) {
                let h = [];
                // loop through range of sections
                for(let x = ranges[r].start; x <= ranges[r].end; x++) {
                    // store native section height
                    let rect = this.items[x].sections[i].getBoundingClientRect();
                    h.push(rect.height);
                }
                // get largest height value
                let result = Math.ceil(Math.max(...h));
                // set all to min-height = largest height
                for(let x = ranges[r].start; x <= ranges[r].end; x++) {
                    this.items[x].sections[i].style.minHeight = result + 'px';
                }
            }
        }
    }

    requestResize() {
        clearTimeout(this.resizeTimeout);
        this.resizeRequested = true;
        this.resizeTimeout = setTimeout(() => {
            this.resize();
        }, 50);
    }

    resize() {
        this.clearSections();
        this.update();
    }

}

// export the default function to create
export function createFrom(wrappers) {
    wrappers.forEach((node) => {
        // if node is an element
        if (node.nodeType === 1) {
            new HeightMatchGroup(node);
        }
    });
}